const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const getDateStringFromTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

const getDateStringWithoutYearFromTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
}

const getDateStringPlusOneMonthWithoutYearFromTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);
  date.setMonth(date.getMonth() + 1)

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
}

const safeText = (value) => {
  if (value === null || value === undefined || value === '') return ',';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

function parseAddress(address) {
  const parts = address.split(',');
  return {
    street: parts[0]?.trim() || '',
    city: parts[1]?.trim() || '',
    zip: parts[2]?.trim() || '',
  };
}
